import { Expose } from "class-transformer";
import { IsBoolean } from "class-validator";

export class OfficeSignature {
  @Expose()
  @IsBoolean()
  certificateIsPresent!: string;
  @Expose()
  @IsBoolean()
  imageIsPresent!: string;
}
